<ng-container *transloco="let t; read: 'home'">
  <div class="p-grid p-nogutter p-jc-center validVehicles">
    <div class="p-col-12 p-text-center validVehicles__header">
      <h2 class="home-heading">
        {{ t('validVehicles.header.part1') }}
      </h2>
      <a
        *ngIf="!onPath('/dla-jakich-pojazdow')"
        routerLink="/dla-jakich-pojazdow"
        >{{ t('tab.showMore') }}</a
      >
    </div>

    <div class="p-col-12 validVehicles__grid">
      <div class="p-grid p-nogutter p-jc-center">
        <div
          *ngFor="let vehicle of validVehicles"
          class="p-col-12 p-md-4 validVehicles__tile">
          <div class="validVehicles__tile__content">
            <div class="p-mb-3 validVehicles__tile__content__image">
              <img
                [src]="vehicle.img"
                [alt]="vehicle.header"
                class="benefit-image"
                [style.border-radius]="vehicle.maxWidth ? '50%' : '0'"
                [style.max-width]="vehicle.maxWidth"
                [style.max-height]="vehicle.maxHeight"
                loading="lazy"
                decoding="async" />
            </div>
            <div class="validVehicles__tile__content__description">
              <h3 class="textBlue p-text-bold p-mb-2">{{ vehicle.header }}</h3>
              <p class="textBlue">{{ vehicle.text }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="p-col-12 p-d-flex p-jc-center backgroundWrapper">
      <div class="p-grid wrapper">
        <div class="p-d-none p-d-md-flex p-md-6 validVehicles__img">
          <img
            class="circle-image"
            src="assets/images/17_SUV.jpg"
            alt="{{ t('validVehicles.where.header.part1') }}"
            loading="lazy"
            decoding="async" width="800" height="800">
          <img
            class="bgImg p-d-none p-d-xl-block"
            src="assets/images/bg1-img.svg"
            alt="tear"
            loading="lazy"
            decoding="async" width="1532" height="1026">
        </div>
        <div class="p-col-12 p-col-nogutter p-md-6 p-d-flex">
          <div class="p-grid">
            <div class="p-col-12">
              <h2 class="home-heading" [innerHTML]="t('validVehicles.where.header.part1')"></h2>
              <h3 class="p-mt-2 p-mb-1">
                {{ t('validVehicles.where.subtitle.main') }}
              </h3>
              <p class="p-text-small textGrey p-mb-3">
                {{ t('validVehicles.where.subtitle.small') }}
              </p>

              <div class="p-col-12 p-d-md-none validVehicles__img">
                <img
                  class="circle-image"
                  src="assets/images/17_SUV.jpg"
                  alt="Ochrona bez granic w całej Europie"
                  loading="lazy"
                  decoding="async" width="800" height="800">
              </div>

              <div
                class="validVehicles__where p-col-12 p-d-md-none p-d-xl-block">
                <p class="textBlue p-text-bold p-mb-2">
                  {{ t('validVehicles.where.right.header') }}
                </p>
                <ol class="validVehicles__where__list p-pl-3 p-mb-0">
                  <li
                    class="p-mb-1 textBlue"
                    [innerHTML]="t('validVehicles.where.right.1')"></li>
                  <li
                    class="p-mb-1 textBlue"
                    [innerHTML]="t('validVehicles.where.right.2')"></li>
                  <li
                    class="p-mb-1 textBlue"
                    [innerHTML]="t('validVehicles.where.right.3')"></li>
                </ol>
              </div>
            </div>
          </div>
        </div>
        <div
          class="validVehicles__where p-d-none p-md-12 p-d-md-block p-d-xl-none">
          <p class="textBlue p-text-bold p-mb-2">
            {{ t('validVehicles.where.right.header') }}
          </p>
          <ol class="validVehicles__where__list p-pl-3 p-mb-0">
            <li
              class="p-mb-1 textBlue"
              [innerHTML]="t('validVehicles.where.right.1')"></li>
            <li
              class="p-mb-1 textBlue"
              [innerHTML]="t('validVehicles.where.right.2')"></li>
            <li
              class="p-mb-1 textBlue"
              [innerHTML]="t('validVehicles.where.right.3')"></li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</ng-container>
